import { render } from "./ChatChooser.vue?vue&type=template&id=04d0021a"
import script from "./ChatChooser.vue?vue&type=script&lang=js"
export * from "./ChatChooser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__